var Web3 = require('web3');

import {
  wiseContractAddress,
  wiseContractABI
} from "./contract_testnet_staking_7_0xa89Cb3AA23F7d85DEF5dCCdb73450aE236AFEe61"
// } from "./contract_testnet_staking_6_0xDb4de4303295c0E7559449aB4d121bFB4EE235AE"
// } from "./contract_testnet_staking_5_0x2306c52A206b2e847892496c29895217950d20e4"
// } from "./contract_testnet_staking_4_0x01a4bE2303E350f4b512F7C8962E3Ba1274BDBDc"
// } from "./contract_testnet_staking_3_0xd48f665c6ded0d76a015b99bc944545831224db6"
// } from "./contract_testnet_staking_2_0x906e19f85f8462B69b5F782bdC3703274f2AfC17"
// } from "./contract_testnet_staking_1_0x538889fb05329e6923e6e14696a001605590a155"

var wiseContract = null;
var web3 = null;
var infuraWiseContract = null;
var infuraWeb3 = null;

// async function createContract() {
//   web3 = new Web3(window.ethereum);
//   await window.ethereum.enable();
//
//   wiseContract = await new web3.eth.Contract(wiseContractStakingABI, wiseContractStakingAddress);
// }

async function createContract() {
  web3 = new Web3(window.ethereum);
  await window.ethereum.enable();

  wiseContract = await new web3.eth.Contract(wiseContractABI, wiseContractAddress);
}

async function createInfuraContract() {
  var options = {
    timeout: 30000, // ms
    clientConfig: {
      maxReceivedFrameSize: 100000000,   // bytes - default: 1MiB
      maxReceivedMessageSize: 100000000, // bytes - default: 8MiB
    },
    reconnect: {
        auto: true,
        delay: 5000, // ms
        maxAttempts: 5,
        onTimeout: false
    }
  };

  let wsUrl = "wss://ropsten.infura.io/ws/v3/2b96a15340b4464784244064e9b1899c";
  infuraWeb3 = new Web3(new Web3.providers.WebsocketProvider(wsUrl, options));

  infuraWiseContract = await new infuraWeb3.eth.Contract(wiseContractABI, wiseContractAddress);
}


export async function getWeb3() {
  if (web3 === null) {
    // console.log("web3 does not exist -> createContract");
    await createContract();
  } else {
    // console.log("web3 available");
  }
  return web3;
}

export async function getWiseContract() {
  if (wiseContract === null) {
    // console.log("wiseContract does not exist -> createContract");
    await createContract();
  } else {
    // console.log("wiseContract available");
  }
  return wiseContract;
}

export async function getInfuraWeb3() {
  if (infuraWeb3 === null) {
    // console.log("infuraWeb3 does not exist -> createContract");
    await createInfuraContract();
  } else {
    // console.log("infuraWeb3 available");
  }
  return infuraWeb3;
}

export async function getInfuraWiseContract() {
  if (infuraWiseContract === null) {
    // console.log("infuraWiseContract does not exist -> createContract");
    await createInfuraContract();
  } else {
    // console.log("infuraWiseContract available");
  }
  return infuraWiseContract;
}
